import { render, staticRenderFns } from "./requestform.vue?vue&type=template&id=6543986b"
import script from "./requestform.vue?vue&type=script&lang=js"
export * from "./requestform.vue?vue&type=script&lang=js"
import style0 from "./requestform.vue?vue&type=style&index=0&id=6543986b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports